import Client from "lib/api/Client";
let Notifications = {
  get: async function(startIndex, limit, params, includeClients = false){
    try{
    const authToken = await localStorage.getItem("token");
    let url = `${process.env.REACT_APP_API_BASE_URL}/notification/?offset=${startIndex}&limit=${limit}`;
    if (params) {
      params = new URLSearchParams(params).toString().replace("%2C", ",");
      if (params.length > 0)
      {
        url = url + `&${params}`;
      }
    }
    // let query_string = props ? `?${new URLSearchParams(props).toString()}`: "";
    const request = new Request(url, {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: authToken
      })
    });
    const response = await fetch(request);

    if(response.status === 401){
      await localStorage.removeItem("token");
      throw new Error('Unauthorized');
    }

    const json = await response.json();

    // Validate that data is an array - if not, API returned an error (e.g., size limit exceeded)
    if (!Array.isArray(json.data)) {
      console.error('API returned non-array data:', json.data);
      console.error('Full response:', json);
      return {
        data: [],
        pagination: json.pagination || { offset: 0, limit: 0, total: 0 },
        status: json.status || 200
      };
    }

    const notifications = json.data;

    // Only enrich with client data if explicitly requested
    if (includeClients) {
      // Extract unique client_uuids from notifications
      const uniqueClientUuids = [...new Set(notifications.map(notification => notification.target_uuid))];

      // Fetch client information if there are any client_uuids
      let clients = [];
      const validClientUuids = uniqueClientUuids.filter(uuid => uuid);
      if (validClientUuids.length > 0) {
        try {
          // If we have <= 100 clients, make a single request
          if (validClientUuids.length <= 100) {
            const clientsResponse = await Client.get({
              uuid: validClientUuids.join(','),
              limit: validClientUuids.length,
              fields: 'uuid,name'
            });
            clients = clientsResponse?.data || [];
          } else {
            // If we have > 100 clients, batch the requests
            const batches = [];
            for (let i = 0; i < validClientUuids.length; i += 100) {
              batches.push(validClientUuids.slice(i, i + 100));
            }

            const batchPromises = batches.map(batch =>
              Client.get({
                uuid: batch.join(','),
                limit: batch.length,
                fields: 'uuid,name'
              })
            );

            const batchResponses = await Promise.all(batchPromises);
            clients = batchResponses.reduce((acc, response) => {
              return acc.concat(response?.data || []);
            }, []);
          }
        } catch (error) {
          console.error('Failed to fetch client data:', error);
          clients = [];
        }
      }

      // Create a map of client_uuid to client name
      const clientUuidToName = clients.reduce((acc, client) => {
        acc[client.uuid] = client.name; // Assuming each client object has 'uuid' and 'name'
        return acc;
      }, {});

      // Enrich notifications with client names
      const enrichedNotifications = notifications.map(notification => ({
        ...notification,
        client_name: clientUuidToName[notification.target_uuid] || 'Unknown Client'
      }));

      json.data = enrichedNotifications;
    }

    return { ...json };
  }catch(exception){
    console.log(exception);
  }
  },
  list: async function(startIndex, limit, search) {
    const authToken = await localStorage.getItem("token");
    var url = `${process.env.REACT_APP_API_BASE_URL}/notification/?offset=${startIndex}&limit=${limit}`;
    if (search) {
      url = url + `&search=${encodeURI(search)}`;
    }
    console.log(url);
    const request = new Request(url, {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: authToken
      })
    });
    const response = await fetch(request);
    const json = await response.json();

    const notifications = json.data;
    const uniqueClientUuids = [...new Set(notifications.map(notification => notification.target_uuid))];

    let clients = [];
    const validClientUuids = uniqueClientUuids.filter(uuid => uuid);
    if (validClientUuids.length > 0) {
      try {
        // If we have <= 100 clients, make a single request
        if (validClientUuids.length <= 100) {
          const clientsResponse = await Client.get({
            uuid: validClientUuids.join(','),
            limit: validClientUuids.length,
            fields: 'uuid,name'
          });
          clients = clientsResponse?.data || [];
        } else {
          // If we have > 100 clients, batch the requests
          const batches = [];
          for (let i = 0; i < validClientUuids.length; i += 100) {
            batches.push(validClientUuids.slice(i, i + 100));
          }
          
          const batchPromises = batches.map(batch =>
            Client.get({
              uuid: batch.join(','),
              limit: batch.length,
              fields: 'uuid,name'
            })
          );
          
          const batchResponses = await Promise.all(batchPromises);
          clients = batchResponses.reduce((acc, response) => {
            return acc.concat(response?.data || []);
          }, []);
        }
      } catch (error) {
        console.error('Failed to fetch client data:', error);
        clients = [];
      }
    }

    // Create a map of client_uuid to client name
    const clientUuidToName = clients.reduce((acc, client) => {
      acc[client.uuid] = client.name; // Assuming each client object has 'uuid' and 'name'
      return acc;
    }, {});

    const notificationsWithClientName = notifications.map(notification => ({
      ...notification,
      client_name: clientUuidToName[notification.target_uuid] || 'Unknown Client'
    }));

    return { data: notificationsWithClientName, total: json.pagination.total };
  },
  create: async function(notifications) {
    const authToken = await localStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/notification/`,
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken
        }),
        body: JSON.stringify(notifications)
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  update: async function(uuid, notification) {
    const authToken = await localStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/notification/${uuid}`,
      {
        method: "PUT",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken
        }),
        body: JSON.stringify(notification)
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  delete: async function(uuid) {
    try{
      const authToken = await localStorage.getItem("token");
      const request = new Request(
        `${process.env.REACT_APP_API_BASE_URL}/notification/${uuid}`,
        {
          method: "DELETE",
          headers: new Headers({
            "Content-Type": "application/json",
            Authorization: authToken
          })
        }
      );
      return await fetch(request);
    }catch(exception){
      console.log("api error");
      console.log(exception);
    }
  },
  load: async function(uuid) {
    const authToken = await localStorage.getItem("token");
    var url = `${process.env.REACT_APP_API_BASE_URL}/notification/${uuid}`;
    const request = new Request(url, {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: authToken
      })
    });
    const response = await fetch(request);
    const json = await response.json();
    return json;
  },
  getGroupedBySource: async function(startIndex, limit, params) {
    try {
      const authToken = await localStorage.getItem("token");
      let url = `${process.env.REACT_APP_API_BASE_URL}/notification/by-source?offset=${startIndex}&limit=${limit}`;
      if (params) {
        params = new URLSearchParams(params).toString().replace("%2C", ",");
        if (params.length > 0) {
          url = url + `&${params}`;
        }
      }
      const request = new Request(url, {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken
        })
      });
      const response = await fetch(request);

      if(response.status === 401){
        await localStorage.removeItem("token");
        throw new Error('Unauthorized');
      }

      const json = await response.json();
      return json;
    } catch(exception) {
      console.log(exception);
      throw exception;
    }
  },
  updateBySource: async function(source_uuid, notification) {
    const authToken = await localStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/notification/by-source/${source_uuid}`,
      {
        method: "PUT",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken
        }),
        body: JSON.stringify(notification)
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  deleteBySource: async function(source_uuid) {
    try {
      const authToken = await localStorage.getItem("token");
      const request = new Request(
        `${process.env.REACT_APP_API_BASE_URL}/notification/by-source/${source_uuid}`,
        {
          method: "DELETE",
          headers: new Headers({
            "Content-Type": "application/json",
            Authorization: authToken
          })
        }
      );
      return await fetch(request);
    } catch(exception) {
      console.log("api error");
      console.log(exception);
      throw exception;
    }
  }
};
export default Notifications;